export default __webpack_public_path__ + "static/media/lhype-logo.11f4a003.svg";